var _circle, _circle2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 4535039",
    filter: "url(#filter0_d_2557_1626)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1691",
    cx: 34,
    cy: 30,
    r: 30,
    fill: "#AB5337"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2557_1626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1692",
    cx: 34,
    cy: 30,
    r: 30,
    fill: "#A0ADA6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2557_1626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4535038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.4296 7.52203L33.4167 7.52193C31.9126 7.50982 30.6845 8.77541 30.6736 10.3487L30.2699 68.6671C30.259 70.2404 31.4694 71.5256 32.9735 71.5377L32.9864 71.5378C34.4905 71.5499 35.7186 70.2843 35.7295 68.711L36.1332 10.3927C36.1441 8.81937 34.9337 7.53414 33.4296 7.52203Z",
    fill: "#CED8ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M63.2551 44.073C63.0303 36.2365 59.7295 28.801 54.0685 23.3787C48.4074 17.9565 40.8424 14.9845 33.0138 15.1072C25.1852 15.23 17.7242 18.4374 12.2483 24.0343C6.77247 29.6312 3.72319 37.1664 3.76177 45.0058L63.2551 44.073Z",
    fill: "#E3E7F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.15377 47.2642L14.0279 110.315C14.1215 110.785 14.3761 111.208 14.7478 111.511C15.1195 111.814 15.5849 111.977 16.0637 111.973L53.1286 111.418C53.6284 111.434 54.1164 111.265 54.4989 110.942C54.8813 110.62 55.1314 110.168 55.2012 109.672L62.9077 46.3468C62.9383 46.0586 62.9066 45.7672 62.8148 45.4923C62.723 45.2173 62.573 44.9653 62.3753 44.7533C62.1777 44.5414 61.9368 44.3744 61.6691 44.2639C61.4014 44.1533 61.1132 44.1016 60.824 44.1125L6.1306 44.9619C5.84268 44.9622 5.55838 45.0247 5.29689 45.145C5.0354 45.2654 4.80295 45.4409 4.61535 45.6593C4.42775 45.8778 4.28947 46.1342 4.20982 46.4111C4.13017 46.6881 4.11101 46.9791 4.15377 47.2642Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M63.1271 40.7603L4.86852 40.926C3.02385 40.9313 1.53427 42.4328 1.5416 44.2799L1.54166 44.2928C1.54899 46.1398 3.05047 47.6328 4.89514 47.6276L63.1537 47.4618C64.9984 47.4566 66.4878 45.9551 66.4805 44.108L66.4804 44.0951C66.4731 42.2481 64.9718 40.7551 63.1271 40.7603Z",
    fill: "#CBD3E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M62.4572 46.7009L55.2278 109.67C55.158 110.165 54.9079 110.618 54.5254 110.94C54.1429 111.262 53.655 111.431 53.1552 111.415L16.0903 111.97C15.6114 111.974 15.146 111.811 14.7744 111.508C14.4027 111.205 14.1481 110.782 14.0545 110.312L4.92836 46.7008L62.4572 46.7009Z",
    fill: "#EED7C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.1747 64.4672C30.7146 63.4642 31.9591 60.5886 30.9544 58.0444C29.9497 55.5002 27.0762 54.2508 24.5364 55.2538C21.9965 56.2567 20.752 59.1323 21.7567 61.6766C22.7614 64.2208 25.6348 65.4702 28.1747 64.4672Z",
    fill: "#D79B7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56.2997 60.7172C58.8396 59.7142 60.0841 56.8386 59.0794 54.2944C58.0747 51.7502 55.2012 50.5008 52.6614 51.5038C50.1215 52.5067 48.877 55.3823 49.8817 57.9266C50.8864 60.4708 53.7598 61.7202 56.2997 60.7172Z",
    fill: "#D79B7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.1747 57.9047C15.7146 56.9017 16.9591 54.0261 15.9544 51.4819C14.9497 48.9377 12.0762 47.6883 9.53635 48.6913C6.99648 49.6942 5.75197 52.5698 6.75668 55.1141C7.76138 57.6583 10.6348 58.9077 13.1747 57.9047Z",
    fill: "#D79B7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.8095 32.9851C32.8774 32.9687 31.9766 32.6433 31.2484 32.0599C31.2103 32.0317 31.1785 31.996 31.1547 31.955C31.1309 31.9141 31.1158 31.8687 31.1101 31.8217C31.1045 31.7747 31.1085 31.7271 31.122 31.6817C31.1354 31.6364 31.1581 31.5942 31.1884 31.5579C31.2473 31.4841 31.3328 31.4365 31.4266 31.4253C31.5204 31.4142 31.6149 31.4403 31.6896 31.4983C31.7274 31.594 33.8586 33.2146 35.5447 31.4698C35.5766 31.4343 35.6156 31.406 35.6591 31.3863C35.7025 31.3666 35.7495 31.356 35.7972 31.3554C35.8449 31.3547 35.8922 31.3639 35.9362 31.3824C35.9802 31.4009 36.0199 31.4282 36.0529 31.4628C36.0861 31.495 36.1126 31.5335 36.1308 31.576C36.149 31.6186 36.1586 31.6644 36.1588 31.7107C36.1591 31.757 36.1501 31.8028 36.1324 31.8456C36.1147 31.8883 36.0886 31.9271 36.0557 31.9596C35.7699 32.2734 35.4236 32.526 35.0375 32.7023C34.6515 32.8785 34.2338 32.9747 33.8095 32.9851Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.6338 35.1721C24.844 34.2993 25.927 31.7969 25.0527 29.5829C24.1784 27.369 21.6779 26.2817 19.4677 27.1545C17.2575 28.0273 16.1746 30.5297 17.0489 32.7436C17.9232 34.9576 20.4236 36.0449 22.6338 35.1721Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.7028 31.2458C16.6859 30.6755 16.7822 30.1076 16.9864 29.5752C17.1905 29.0427 17.4983 28.5562 17.8918 28.144C18.2853 27.7318 18.7567 27.402 19.2788 27.1738C19.8008 26.9456 20.3629 26.8235 20.9327 26.8147C21.5024 26.8058 22.0685 26.9104 22.5979 27.1223C23.1272 27.3341 23.6094 27.6489 24.0164 28.0487C24.4235 28.4485 24.7473 28.9252 24.969 29.4511C25.1908 29.9769 25.3061 30.5415 25.3082 31.1121",
    fill: "#51260E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M21.7865 31.1073C21.7924 31.7811 21.534 32.43 21.0669 32.9146C20.5997 33.3991 19.9611 33.6806 19.2884 33.6984C18.6154 33.7035 17.9671 33.4439 17.4826 32.9756C16.9982 32.5073 16.7164 31.8677 16.6977 31.1941",
    fill: "#47220D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M48.1075 34.7797C50.3177 33.9069 51.4006 31.4046 50.5264 29.1906C49.6521 26.9766 47.1516 25.8894 44.9414 26.7622C42.7312 27.635 41.6482 30.1373 42.5225 32.3513C43.3968 34.5653 45.8973 35.6525 48.1075 34.7797Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M42.1767 30.8427C42.1725 29.7096 42.6143 28.6207 43.4063 27.8122C44.1984 27.0037 45.277 26.5405 46.4086 26.5229C47.5402 26.5054 48.6337 26.9349 49.4523 27.7184C50.2709 28.5019 50.7486 29.5763 50.7821 30.709",
    fill: "#51260E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M47.264 30.7181C47.192 31.3376 46.8976 31.9096 46.4356 32.3275C45.9736 32.7455 45.3754 32.9808 44.7524 32.99C44.1295 32.9992 43.5243 32.7814 43.0493 32.3772C42.5743 31.9731 42.2619 31.4101 42.1704 30.793",
    fill: "#47220D"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2557_1626",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2557_1626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2557_1626",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatarDefault);
export default __webpack_public_path__ + "static/media/boba-avatar-default.64955d64.svg";
export { ForwardRef as ReactComponent };